export const portalRootId = 'portalRoot';
